import { getCountryDataByCode, ZipStatus } from '@chegg/commerce-utils';
import { UnsupportedZip } from '../constants/UnsupportedZip';
export var isHidden = function isHidden(countryData) {
  return countryData ?
  // hiding zipcode field for optional countries as well
  countryData.zipStatus === ZipStatus.hidden || !countryData.zipStatus : false;
};
export var isMandatory = function isMandatory(countryData) {
  return countryData ? countryData.zipStatus === ZipStatus.mandatory : false;
};

/* Uncomment this for optional zip code field
export const isOptional = (countryData: CountryData | undefined): boolean =>
  countryData
    ? countryData.zipStatus === ZipStatus.optional || !countryData.zipStatus
    : false;
*/

export var isZipMandatory = function isZipMandatory(countryCode) {
  var countryData = getCountryDataByCode(countryCode);
  return countryData ? isMandatory(countryData) : false;
};

/* Uncomment this for optional zip code field
// NOTE: if and when you uncomment this code again, please make sure that RIO logs are fired for countries with zipcode optional
export const isZipOptional = (countryCode: string): boolean => {
  const countryData = getCountryDataByCode(countryCode);
  return countryData ? isOptional(countryData) : false;
};
*/

export var isCountryWithNoZipcode = function isCountryWithNoZipcode(countryCode) {
  var countryData = getCountryDataByCode(countryCode);
  // defaults to country as no zipcode. Else regex or SS might fail
  return countryData ? isHidden(countryData) : true;
};
export var invalidZipcode = function invalidZipcode(zipcode, countryCode) {
  //@ts-ignore
  return UnsupportedZip[countryCode] ?
  //@ts-ignore
  UnsupportedZip[countryCode].indexOf(zipcode) !== -1 : false;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/utils/ZipUtil.js
// module id = 492
// module chunks = 11